import { render, staticRenderFns } from "./CartStep3.vue?vue&type=template&id=2f4ea6b8&scoped=true&"
import script from "./CartStep3.vue?vue&type=script&lang=js&"
export * from "./CartStep3.vue?vue&type=script&lang=js&"
import style0 from "./CartStep3.vue?vue&type=style&index=0&id=2f4ea6b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4ea6b8",
  null
  
)

export default component.exports